<template lang="pug">
	.tracking-native-reports-control
		small.text-muted Here you can download native tracking reports.
		.buttons
			button.btn.btn-sm.btn-outline-primary(type="button" v-on:click="downloadForThisVersion()")
				span Download for this version
			button.btn.btn-sm.btn-outline-primary(type="button" v-on:click="downloadForProject()")
				span Download for whole project
</template>

<script>

	import Screen 				from '../../../mixins/screen';

	import { Project } 			from '../../../services/Project';
	import { Settings } 		from '../../../services/Settings';
	import { Version } 			from '../../../services/Version';

	export default {
		name: "TrackingNativeReports",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Changed",
				"Selected Version Settings Loaded",
				"Selected Version Settings Original Loaded",
				"Selected Version Setting Changed:end-card-version-id",
				"Settings Tab Changed:templates"
			]
		},
		props: ['setting'],
		data() {

			this.Project = Project;
			this.Settings = Settings;

			this.endCard = null;

			return {
				showed: true
			}

		},
		methods: {
			downloadForThisVersion() {
				let url = `https://tracking.mraid.io/reports/xlsx/${Project.SelectedProject.id}/${this.setting['version_id']}`;
				window.open(url, '_blank');
			},

			downloadForProject() {
				let url = `https://tracking.mraid.io/reports/xlsx/${Project.SelectedProject.id}`;
				window.open(url, '_blank');
			}
		}
	}
</script>

<style lang="sass">
	.buttons 
		display: flex
		gap: 5px

</style>
